// components/Footer.jsx
import React from "react";
import "../component/css/footer.css";
import { FaPhone, FaEnvelope } from "react-icons/fa";

function Footer() {
  return (
    <footer className="ygm-footer">
      <div className="footer-bottom">
        <div className="left-links">
          <a href="https://yourgutmap.co.uk/privacy-policy/?v=1cd3c693132f">
            Privacy Policy
          </a>
          <a href="https://yourgutmap.co.uk/terms-and-conditions/?v=1cd3c693132f">
            Terms & Condition
          </a>
        </div>
        <div className="copyright">
          GutMapDx Copyright 2024-25 © All rights Reserved.
        </div>
      </div>

      <div className="footer-desktop">
        <div className="footer-content desktop-footer">
          <div className="footer-section logo-section">
            <img
              // src="https://yourgutmap.co.uk/wp-content/uploads/2023/03/ygm-logo.png"
              src="/GutMapDxLogo.png"
              alt="Your Gut Map Logo"
              className="ygm-logo"
            />
          </div>

          <div className="footer-section text">
            <h4>About</h4>
            <ul>
              <li>
                <a href="https://yourgutmap.co.uk/science/">Science</a>
              </li>
              <li>
                <a href="https://yourgutmap.co.uk/shop/">Shop</a>
              </li>
            </ul>
          </div>

          <div className="footer-section text">
            <h4>Connect</h4>
            <ul>
              <li>
                <a href="https://yourgutmap.co.uk/contact/">Contact</a>
              </li>
              <li>
                <a href="https://yourgutmap.co.uk/practitioners/">
                  Practitioners
                </a>
              </li>
              <li>
                <a href="https://yourgutmap.co.uk/events/">Events</a>
              </li>
            </ul>
          </div>

          <div className="footer-section text">
            <h4>Address</h4>
            <div className="footer-section text address">
              <div>GutMapDx</div>
              <div>York Health Sciences</div>
              <div>Unit 4 Utilities House</div>
              <div>Osbaldwick</div>
              <div>York</div>
              <div>YO19 5UP</div>
            </div>
          </div>

          <div className="footer-section conctactnow">
            <h4>Contact</h4>
            <a href="mailto:info@yourgutmap.co.uk">
              <FaEnvelope style={{ marginRight: "8px" }} />{" "}
              info@yourgutmap.co.uk
            </a>
            <a href="tel:01904 530 770">
              <FaPhone style={{ marginRight: "8px" }} /> 01904 530 770
            </a>
            <p>A GutMap LLC company.</p>
            <img
              // src="https://yourgutmap.co.uk/wp-content/uploads/2024/03/gutmapllc.png"
              src="https://yourgutmap.co.uk/wp-content/uploads/2023/03/gutmap-llc-04-300x68.png"
              alt="GutMap LLC"
              className="gutmap-llc-logo"
              width={"200px"}
            />
          </div>
        </div>
      </div>
      <div className="footer-mobile">
        <div className="new-footer-content footer-content mobile-footer">
          <div className="footer-section logo-section">
            <img
              // src="https://yourgutmap.co.uk/wp-content/uploads/2023/03/ygm-logo.png"
              src="/GutMapDxLogo.png"
              alt="Your Gut Map Logo"
              className="ygm-logo"
            />
          </div>

          <div className="footer-section text">
            <h4>About</h4>
            <ul>
              <li>
                <a href="https://yourgutmap.co.uk/science/">Science</a>
              </li>
              <li>
                <a href="https://yourgutmap.co.uk/shop/">Shop</a>
              </li>
            </ul>
          </div>
          <div className="footer-section text">
            <h4>Address</h4>
          <div className="footer-section text address">
              <div>GutMapDx</div>
              <div>York Health Sciences</div>
              <div>Unit 4 Utilities House</div>
              <div>Osbaldwick</div>
              <div>York</div>
              <div>YO19 5U</div>
            </div>
          </div>

          <div className="footer-section conctactnow">
            <h4>Contact Now</h4>
            <p className="mobileinfo">
              <FaEnvelope style={{ marginRight: "8px" }} />{" "}
              info@yourgutmap.co.uk
            </p>
            <p>
              <FaPhone style={{ marginRight: "8px" }} /> 01904 530 770
            </p>
          </div>
          <div className="footer-section text">
            <h4>Connect</h4>
            <ul>
              <li>
                <a href="https://yourgutmap.co.uk/contact/">Contact</a>
              </li>
              <li>
                <a href="https://yourgutmap.co.uk/practitioners/">
                  Practitioners
                </a>
              </li>
              <li>
                <a href="https://yourgutmap.co.uk/events/">Events</a>
              </li>
            </ul>
          </div>
          <div className="footer-section text">
            <h4>A GutMap LLC company.</h4>
            <img
              // src="https://yourgutmap.co.uk/wp-content/uploads/2024/03/gutmapllc.png"
              src="https://yourgutmap.co.uk/wp-content/uploads/2023/03/gutmap-llc-04-300x68.png"
              // src="/GutMapDxLogo.png"
              alt="GutMap LLC"
              className="gutmap-llc-logo"
              width={"200px"}
            />
          </div>
        </div>
      </div>

      <hr />
    </footer>
  );
}

export default Footer;